import React, {Component} from 'react'
import {
    Form,
    Select,
    Input,
    Table,
    Button,
    Radio,
    Row,
    Col,
    message,
    DatePicker,
    Popconfirm
} from 'antd';
import CarbinPackageModal from './carbin-modal';
import SpaceModel from './preview/spaceModel'
import {toStrFixed} from '../../utills/subStringUtill'
import {reqKtCabin, reqAddress, reqKtCreateCabin, reqKtUpdateCabin, reqKtBook, baseUrl, reqArea} from '../../api';
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
moment.locale('zh-cn');

const {Option} = Select;
let orderId;
class KtOrderSpace extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previewData: {},  // 预览数据
            cabinPackageVoList: [],
            previewVisiable: false,
            formLayout: 'horizontal',
            cabin: [],
            shipper: [],
            consignee: [],
            editingKey: '',//当前编辑的key
            action: '',//当前编辑是add还是edit
            count: '',//table中最大的key值 应该=table.length
            fromCitys: [],
            toCitys: [],
            loading: false,
        };
    }

    componentDidMount() {
        orderId = this.props.location.state.orderId;
        const space = JSON.parse(sessionStorage.getItem("space"));
        if (space) {
            const boxDt = space.boxDt ? moment(space.boxDt, 'YYYY-MM-DD') : null;
            const boxEndDt = space.boxEndDt ? moment(space.boxEndDt, 'YYYY-MM-DD') : null;
            this.props.form.setFieldsValue({boxDt, boxEndDt});
            this.setState(space);
        } else {
            this.getCabin(orderId);
        }
        this.getAddress(14, orderId);
        this.getAddress(11, orderId);
        this.getAddress(13, orderId);
    }

    componentWillUnmount() {
        const curData = this.props.form.getFieldsValue();
        const stateData = {...this.state};
        Object.assign(stateData, curData);
        stateData.boxDt = this.state.boxDt;
        stateData.boxEndDt = this.state.boxEndDt;
        sessionStorage.setItem('space', JSON.stringify(stateData));
    }

    judgeReadOnly = orderStatus => {
        if (orderStatus != 'unbooked') {
            return true;
        }
        return false;
    };
    getCabin = async (orderId) => {
        const result = await reqKtCabin(orderId);
        if (result.code === 200) {
            result.data.cabinPackageVoList.map((o, index) => {
                o.key = index + 1;
                if (!o.ifPlan) {
                    o.ifPlan = 'N';
                }
            });
            result.data.count = result.data.cabinPackageVoList.length;
            this.setState({...result.data, readOnly: this.judgeReadOnly(result.data.orderStatus)}, () => {
                this.initFromToCitys()
            });
            const boxDt = result.data.boxDt ? moment(result.data.boxDt, 'YYYY-MM-DD') : null;
            const boxEndDt = result.data.boxEndDt ? moment(result.data.boxEndDt, 'YYYY-MM-DD') : null;
            this.props.form.setFieldsValue({boxDt, boxEndDt});
        } else if (result.code === 401) {
            message.error(result.message)
        }

    };
    createCabin = async (po) => {
        const result = await reqKtCreateCabin(po);
        if (result.code === 201) {
            this.setState(result.data)
            message.success(result.message);
        } else {
            message.error(result.message);
        }
    };
    updateCabin = async (po) => {
        const result = await reqKtUpdateCabin(po);
        if (result.code === 200) {
            this.setState(result.data)
            message.success(result.message);
        } else {
            message.error(result.message);
        }
    };
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values.boxDt = this.state.boxDt;
                values.boxEndDt = this.state.boxEndDt;
                values.id = this.state.id;
                values.orderId = orderId;
                values.cabinPackagePoList = this.state.cabinPackageVoList;
                values.originCountry = this.state.originCountry;
                values.originCity = this.state.originCity;
                values.destinationCountry = this.state.destinationCountry;
                values.destinationCity = this.state.destinationCity;
                if (this.state.id) {
                    this.updateCabin(values);
                } else {
                    this.createCabin(values);
                }
            }
        });
    };
    serviceAreaOnChange = e => {
        this.setState({
            serviceArea: e.target.value,
        });
    };
    boxTypeOnChange = e => {
        this.setState({
            boxType: e.target.value,
        });
    };
    declareTypeOnChange = e => {
        this.setState({
            declareType: e.target.value,
        });
    };
    clearTypeOnChange = e => {
        this.setState({
            clearType: e.target.value,
        });
    };
    deliveryMethodOnChange = e => {
        this.setState({
            deliveryMethod: e.target.value,
        });
    };
    getAddress = async (type, orderId) => {
        const result = await reqAddress(type, orderId);
        if (result.code === 200) {
            if (type == 14) {
                this.setState({cabin: result.data})
            }
            if (type == 11) {
                this.setState({shipper: result.data})
            }
            if (type == 13) {
                this.setState({consignee: result.data})
            }
        }
    };
    cabinHandleChange = (key) => {
        const cabin = this.state.cabin[key];
        this.props.form.setFieldsValue({
            cabinAddr: cabin.address,
            cabinContact: cabin.contact,
            cabinMail: cabin.email,
            cabinName: cabin.company,
            cabinPhone: cabin.phone
        })
    };
    shipperHandleChange = (key) => {
        const o = this.state.shipper[key];
        this.props.form.setFieldsValue({
            shipperAddr: o.address,
            shipperContact: o.contact,
            shipperMail: o.email,
            shipperName: o.company,
            shipperPhone: o.phone,
            // chargeContact: o.thirdpartContact
        })
    };
    consigneeHandleChange = (key) => {
        const o = this.state.consignee[key];
        this.props.form.setFieldsValue({
            consigneeAddr: o.address,
            consigneeContact: o.contact,
            consigneeMail: o.email,
            consigneeName: o.company,
            consigneePhone: o.phone,
            // arriveContact: o.thirdpartContact
        })
    };
    onRef = (ref) => {
        this.child = ref;
    };
    //显示弹窗
    editDataSource = (data) => {
        this.setState({
            visible: true,
            editingKey: data.key,
            action: 'edit'
        });
        this.child.props.form.setFieldsValue(data);
    };
    //显示弹窗
    showModal = () => {
        const count = this.state.count + 1;
        this.setState({
            visible: true,
            editingKey: count,
            count: count,
            action: 'add'
        });
    };
    //取消弹窗
    hideModal = () => {
        this.setState({
            visible: false
        })
    };

    //下载PDF
    downloadPdf = () => {
        var name = "cabin";
        orderId = this.props.location.state.orderId;
        if (orderId != null && orderId != "") {
            window.location.href = baseUrl + "/api/v1/p/file/ktFileDownload?id=" + orderId + "&name=" + name;
        } else {
            message.error("该订舱单不存在,请先保存订舱单")
        }
    };

    // 预览弹框
    //显示弹窗
    previewShowModal = () => {
        // const previewData = this.state
        let previewData = this.state;
        let formData = this.props.form.getFieldsValue();
        delete formData.boxDt;
        previewData = Object.assign(previewData,formData);
        console.log(previewData,'pre')
        this.setState({
            previewVisiable: true,
            previewData: previewData
        });
    };


    //取消弹窗
    previewhideModal = () => {
        this.setState({
            previewVisiable: false,
        })
    };
    handleDelete = key => {
        const cabinPackageVoList = [...this.state.cabinPackageVoList];
        this.setState({cabinPackageVoList: cabinPackageVoList.filter(item => item.key !== key)});
    };
    //储存数据
    saveData = (values) => {
        //values.totalValue = values.value//toStrFixed(values.value * values.pcsNumber);
        const editingKey = this.state.editingKey;
        if (this.state.action === 'add') {
            const {cabinPackageVoList} = this.state;
            cabinPackageVoList.push(values);
            this.setState({cabinPackageVoList: cabinPackageVoList})
        } else {
            const newData = [...this.state.cabinPackageVoList];
            const index = newData.findIndex(item => editingKey === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...values,
                });
                this.setState({cabinPackageVoList: newData});
            }
        }
    };
    //订舱确认
    confirmBook = async () => {
        orderId = this.props.location.state.orderId;
        const result = await reqKtBook(orderId);
        if (result.code == 200) {
            this.props.history.replace('/kt-orders')
        } else {
            message.error(result.message)
        }

    };
    initFromToCitys = async () => {
        this.setState({loading: true});
        let resultfrom = await reqArea("F");
        if (resultfrom) {
            this.setState({fromCitys: resultfrom.data}, () => {
                let origin = this.state.fromCitys.findIndex(item => item.countryName === this.state.originCountry && item.cityName === this.state.originCity)
                if (origin > -1) {
                    this.setState({
                        origin: origin,
                    })
                    this.props.form.setFieldsValue({
                        origin: origin,
                    });
                }
            });
        } else {
            this.setState({fromCitys: []});
        }
        let resultto = await reqArea("T");
        if (resultto) {
            this.setState({toCitys: resultto.data}, () => {
                let destination = this.state.toCitys.findIndex(item => item.countryName === this.state.destinationCountry && item.cityName === this.state.destinationCity)
                if (destination > -1) {
                    this.setState({
                        destination: destination,
                    })
                    this.props.form.setFieldsValue({
                        destination: destination,
                    });
                }
            });
        } else {
            this.setState({toCitys: []});
        }
        this.setState({loading: false});

    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 8},
            wrapperCol: {span: 15}
        };
        const monthFormat = 'YYYY-MM';
        const fromOpts = this.state.fromCitys ? this.state.fromCitys.map((d, key) => <Option key={d.cityId}
                                                                                             value={key}>{d.countryName + ' ' + d.cityName}</Option>) : null;
        const toOpts = this.state.toCitys ? this.state.toCitys.map((d, key) => <Option key={d.cityId}
                                                                                       value={key}>{d.countryName + ' ' + d.cityName}</Option>) : null;
        const cabinOpts = this.state.cabin ? this.state.cabin.map((d, key) => <Option key={d.id}
                                                                                      value={key}>{d.company}</Option>) : null;
        const shipperOpts = this.state.shipper ? this.state.shipper.map((d, key) => <Option key={d.id}
                                                                                            value={key}>{d.company}</Option>) : null;
        const consOpts = this.state.consignee ? this.state.consignee.map((d, key) => <Option key={d.id}
                                                                                             value={key}>{d.company}</Option>) : null;
        const columns = [
            {
                title: '序号',
                render: (text, record, index) => `${index + 1}`,
            },
            {
                title: '唛头',
                dataIndex: 'boxNo',
            }, {
                title: '品名(中文)',
                dataIndex: 'name',
            }, {
                title: '品名(英文)',
                dataIndex: 'nameEn',
            }, {
                title: '国内HS',
                dataIndex: 'hscode',
            }, {
                title: '国外HS',
                dataIndex: 'oHscode',
            }, {
                title: '包装',
                dataIndex: 'packageKind',
            }, {
                //     title: '箱数CTNS',
                //     dataIndex: 'num',
                // }, {
                title: '件数',
                dataIndex: 'pcsNumber',
            }, {
                title: '总毛重(Kg)',
                dataIndex: 'grossWeight',
            }, {
                //     title: '净重(Kg)',
                //     dataIndex: 'netWeight',
                // }, {
                title: '总体积(CBM)',
                dataIndex: 'volume',
            }, {
                // title: '单价/币制Value unit',
                // dataIndex: 'value',
                // render: (text, record) => {
                //     if (text && record.currency) {
                //         return text + '/' + record.currency;
                //     }
                // }
                // }, {
                //     title: '总价/币制',
                //     dataIndex: 'value',
                //     render: (text, record) => {
                //         if (text === undefined || text === null) {
                //             return
                //         } else {
                //             return text + '/' + record.currency;
                //         }
                //     }
                // }, {
                //     title: '成分',
                //     dataIndex: 'ingredient',
                // }, {
                //     title: '用途',
                //     dataIndex: 'application',
                // }, {
                title: '是否需要装箱方案',
                dataIndex: 'ifPlan',
                render: (text) => {
                    if (text === 'N') {
                        return '否';
                    } else if (text === 'Y') {
                        return '是';
                    } else {
                        return '';
                    }
                }
            }, {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => {
                    return (
                        <span> <a onClick={() => this.editDataSource(record)}
                                  style={{marginRight: 8}}>
                                        修改
                                    </a>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDelete(record.key)}>
                            <a>删除</a>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];
        const {
            shipperAddr, shipperAddrEn, shipperContact, shipperContactEn, shipperName, shipperNameEn,
            consigneeAddr, consigneeAddrEn, consigneeContact, consigneeContactEn, consigneeName, consigneeNameEn,
        } = this.state;
        return (
            <Form layout={this.state.formLayout} onSubmit={this.handleSubmit} className='order-space'
                  autocomplete='off'>
                <div className="order-base-title">
                    基本信息
                </div>
                <div className="space-base-content">
                    <div className="base-info">
                        <span className='title'>起运地 : </span>
                        <span className='address-detail'>
                            <span
                                className='item'>{this.state.originCountry }&nbsp;{this.state.originCity }</span>
                        </span>
                        <span className='title'>目的地:</span>
                        <span className='address-detail'>
                        <span
                            className='item'>{this.state.destinationCountry}&nbsp;{this.state.destinationCity }</span>
                        </span>
                        <span className='title'>订舱单(委托单编号):</span>
                        <span className='address-detail'>
                        <span className='item'>{this.state.cabinNo }</span>
                        </span>
                    </div>
                    <div className="base-info-msg">
                        <Row>
                            <Col span={12}>
                                <Form.Item label="箱量"{...formItemLayout}>
                                    {getFieldDecorator('containerNum', {
                                        initialValue: this.state.containerNum,
                                        rules: [{required: true, message: '请填写箱量'}]
                                    })(
                                        <Input placeholder='箱量' onChange={e => {
                                            this.setState({containerNum: e.target.value})
                                        }} readOnly={this.state.readOnly}/>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="箱型"{...formItemLayout}>
                                    {getFieldDecorator('containerType', {
                                        initialValue: this.state.containerType,
                                        rules: [{required: true, message: '请填写箱型'}]
                                    })(
                                        <Select disabled={this.state.readOnly}>
                                            <Option key="HC" value="HC">HC</Option>
                                            <Option key="GP" value="GP">GP</Option>
                                            <Option key="车" value="车">车</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="预计装箱开始时间"{...formItemLayout}>
                                    {getFieldDecorator('boxDt', {})(
                                        <DatePicker
                                            showTime
                                            format="YYYY-MM-DD"
                                            style={{width: '100%'}}
                                            disabled={this.state.readOnly}
                                            onChange={(value, dateString) => {
                                                this.setState({
                                                    boxDt: dateString
                                                })
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="预计装箱结束时间"{...formItemLayout}>
                                    {getFieldDecorator('boxEndDt', {})(
                                        <DatePicker
                                            showTime
                                            format="YYYY-MM-DD"
                                            style={{width: '100%'}}
                                            disabled={this.state.readOnly}
                                            onChange={(value, dateString) => {
                                                this.setState({
                                                    boxEndDt: dateString
                                                })
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="在途信息接收邮箱"{...formItemLayout}>
                                    {getFieldDecorator('wayMail', {
                                        initialValue: this.state.wayMail,
                                        rules: [{required: true, message: '请填写在途信息接收邮箱'}]
                                    })(
                                        <Input placeholder='在途信息接收邮箱' onChange={e => {
                                            this.setState({wayMail: e.target.value})
                                        }} readOnly={this.state.readOnly}/>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="计划班期"{...formItemLayout}>
                                    {getFieldDecorator('planTime', {
                                        initialValue: this.state.planTime
                                    })(
                                        <Input onChange={e => {
                                            this.setState({planTime: e.target.value})
                                        }} readOnly={this.state.readOnly}/>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="班列号"{...formItemLayout}>
                                    {getFieldDecorator('squadNumber', {
                                        initialValue: this.state.squadNumber
                                    })(
                                        <Input onChange={e => {
                                            this.setState({squadNumber: e.target.value})
                                        }} readOnly={this.state.readOnly}/>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="order-base-title">
                    订舱方信息
                </div>
                <div className="order-spaceInfo-content">
                    <Select style={{width: '100%'}} onChange={this.cabinHandleChange}
                            getPopupContainer={triggerNode => triggerNode.parentNode} disabled={this.state.readOnly}>
                        {cabinOpts}
                    </Select>
                    <div className='spaceInfo-content-info'>
                        <Row>
                            <Col span={12}>
                                <Form.Item label="订舱方名称" {...formItemLayout}>
                                    {getFieldDecorator('cabinName', {
                                        initialValue: this.state.cabinName,
                                        rules: [{required: true, message: '请填写订舱方名称'}],
                                    })(
                                        <Input placeholder="订舱方名称" onChange={e => {
                                            this.setState({cabinName: e.target.value})
                                        }} readOnly={this.state.readOnly}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="订舱方地址" {...formItemLayout}>
                                    {getFieldDecorator('cabinAddr', {
                                        initialValue: this.state.cabinAddr,
                                        rules: [{required: true, message: '请填写订舱方地址'}],
                                    })(
                                        <Input placeholder="订舱方地址" onChange={e => {
                                            this.setState({cabinAddr: e.target.value})
                                        }} readOnly={this.state.readOnly}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="订舱方联系人" {...formItemLayout}>
                                    {getFieldDecorator('cabinContact', {
                                        initialValue: this.state.cabinContact,
                                        rules: [{required: true, message: '请填写订舱方联系人'}],
                                    })(
                                        <Input placeholder="订舱方联系人" onChange={e => {
                                            this.setState({cabinContact: e.target.value})
                                        }} readOnly={this.state.readOnly}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="联系人电话" {...formItemLayout}>
                                    {getFieldDecorator('cabinPhone', {
                                        initialValue: this.state.cabinPhone,
                                        rules: [{required: true, message: '请填写联系人电话'}],
                                    })(
                                        <Input placeholder="联系人电话" onChange={e => {
                                            this.setState({cabinPhone: e.target.value})
                                        }} readOnly={this.state.readOnly}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="联系人邮箱" {...formItemLayout}>
                                    {getFieldDecorator('cabinMail', {
                                        initialValue: this.state.cabinMail,
                                        rules: [{required: true, message: '请填写联系人邮箱'}],
                                    })(
                                        <Input placeholder="联系人邮箱" onChange={e => {
                                            this.setState({cabinMail: e.target.value})
                                        }} readOnly={this.state.readOnly}/>,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="order-base-title">
                    发货方信息
                </div>
                <div className="order-spaceInfo-content">
                    <Select style={{width: '100%'}} onChange={this.shipperHandleChange}
                            getPopupContainer={triggerNode => triggerNode.parentNode} disabled={this.state.readOnly}>
                        {shipperOpts}
                    </Select>
                    <div className='spaceInfo-content-info'>
                        <Row>
                            <Col span={12}>
                                <Form.Item label="发货方中文名称" {...formItemLayout}>
                                    {getFieldDecorator('shipperName', {
                                        initialValue: shipperName,
                                        rules: [{required: (!shipperNameEn), message: '请填写发货方中文名称'}],
                                    })(
                                        <Input placeholder="发货方中文名称" onChange={e => {
                                            this.setState({shipperName: e.target.value}, () => {
                                                this.props.form.validateFields(['shipperNameEn', {force: true}]);
                                            });
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="发货方英文名称" {...formItemLayout}>
                                    {getFieldDecorator('shipperNameEn', {
                                        initialValue: shipperNameEn,
                                        rules: [{required: (!shipperName), message: '请填写发货方英文名称'}],
                                    })(
                                        <Input placeholder="发货方英文名称" onChange={e => {
                                            this.setState({shipperNameEn: e.target.value}, () => {
                                                this.props.form.validateFields(['shipperName', {force: true}]);
                                            });
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="发货方中文地址" {...formItemLayout}>
                                    {getFieldDecorator('shipperAddr', {
                                        initialValue: shipperAddr,
                                        rules: [{required: (!shipperAddrEn), message: '请填写发货方中文地址'}],
                                    })(
                                        <Input placeholder="发货方中文地址" onChange={e => {
                                            this.setState({shipperAddr: e.target.value}, () => {
                                                this.props.form.validateFields(['shipperAddrEn', {force: true}]);
                                            });
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="发货方英文地址" {...formItemLayout}>
                                    {getFieldDecorator('shipperAddrEn', {
                                        initialValue: shipperAddrEn,
                                        rules: [{required: (!shipperAddr), message: '请填写发货方英文地址'}],
                                    })(
                                        <Input placeholder="发货方英文地址" onChange={e => {
                                            this.setState({shipperAddrEn: e.target.value}, () => {
                                                this.props.form.validateFields(['shipperAddr', {force: true}]);
                                            });
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="发货方中文联系人" {...formItemLayout}>
                                    {getFieldDecorator('shipperContact', {
                                        initialValue: shipperContact,
                                        rules: [{required: (!shipperContactEn), message: '请填写发货方中文联系人'}],
                                    })(
                                        <Input placeholder="发货方中文联系人" onChange={e => {
                                            this.setState({shipperContact: e.target.value}, () => {
                                                this.props.form.validateFields(['shipperContactEn', {force: true}]);
                                            });
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="发货方英文联系人" {...formItemLayout}>
                                    {getFieldDecorator('shipperContactEn', {
                                        initialValue: shipperContactEn,
                                        rules: [{required: (!shipperContact), message: '请填写发货方英文联系人'}],
                                    })(
                                        <Input placeholder="发货方英文联系人" onChange={e => {
                                            this.setState({shipperContactEn: e.target.value}, () => {
                                                this.props.form.validateFields(['shipperContact', {force: true}]);
                                            });
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="联系人电话" {...formItemLayout}>
                                    {getFieldDecorator('shipperPhone', {
                                        initialValue: this.state.shipperPhone,
                                        rules: [{required: true, message: '请填写联系人电话'}],
                                    })(
                                        <Input placeholder="联系人电话" onChange={e => {
                                            this.setState({shipperPhone: e.target.value})
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="联系人邮箱" {...formItemLayout}>
                                    {getFieldDecorator('shipperMail', {
                                        initialValue: this.state.shipperMail,
                                        rules: [{required: true, message: '请填写联系人邮箱'}],
                                    })(
                                        <Input placeholder="联系人邮箱" onChange={e => {
                                            this.setState({shipperMail: e.target.value})
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="单证负责人联系方式" {...formItemLayout}>
                                    {getFieldDecorator('chargeContact', {
                                        initialValue: this.state.chargeContact,
                                        rules: [{required: true, message: '请填写到单证负责人联系方式'}],
                                    })(
                                        <Input placeholder="单证负责人联系方式" onChange={e => {
                                            this.setState({chargeContact: e.target.value})
                                        }}/>,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="order-base-title">
                    收货方信息
                </div>
                <div className="space-base-content">
                    <div className="base-info" style={{height: 'auto'}}>
                        <Row>
                            <Col span={12}>
                                <span className='title'>收货方中文名称 : </span>
                                <span className='address-detail'>{consigneeName}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>收货方英文名称 : </span>
                                <span className='address-detail'>{consigneeNameEn}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>收货方中文地址:</span>
                                <span className='address-detail'>consigneeAddr}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>收货方英文地址:</span>
                                <span className='address-detail'>consigneeAddrEn}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>收货人中文联系人 : </span>
                                <span className='address-detail'>{consigneeContact}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>收货人英文联系人 : </span>
                                <span className='address-detail'>{consigneeContactEn}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>收货人联系方式:</span>
                                <span className='address-detail'>{this.state.consigneePhone}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>收货人联系邮箱:</span>
                                <span className='address-detail'>{this.state.consigneeMail}</span>
                            </Col>
                            <Col span={24}>
                                <span className='title'>到货通知Notify:</span>
                                <span className='address-detail'>{this.state.arriveContact}</span>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="order-base-title">
                    服务内容
                </div>
                <div className="space-service-content">
                    <div className="service-around">
                        <div className="around-item">
                            <Form.Item label="服务范围">
                                {getFieldDecorator('serviceArea', {
                                    initialValue: this.state.serviceArea ? this.state.serviceArea : '4',
                                    rules: [{required: true, message: '请填写服务范围'}]
                                })(
                                    <Radio.Group onChange={this.serviceAreaOnChange} disabled={this.state.readOnly}>
                                        <Radio value={'1'}>门到站</Radio>
                                        <Radio value={'2'}>站到门</Radio>
                                        <Radio value={'3'}>门到门</Radio>
                                        <Radio value={'4'}>站到站</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </div>
                        <div className="around-item">
                            <Form.Item label="箱属">
                                {getFieldDecorator('boxType', {
                                    initialValue: this.state.boxType ? this.state.boxType : '1',
                                    rules: [{required: true, message: '请填写箱属'}]
                                })(
                                    <Radio.Group onChange={this.boxTypeOnChange} disabled={this.state.readOnly}>
                                        <Radio value={'1'}>山口快铁备箱</Radio>
                                        <Radio value={'2'}>订舱方自备箱</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </div>
                        <div className="around-item">
                            <Form.Item label="报关方式">
                                {getFieldDecorator('declareType', {
                                    initialValue: this.state.declareType ? this.state.declareType : '1',
                                    rules: [{required: true, message: '请填写报关方式'}]
                                })(
                                    <Radio.Group onChange={this.declareTypeOnChange} disabled={this.state.readOnly}>
                                        <Radio value={'1'}>山口快铁代办</Radio>
                                        <Radio value={'2'}>订舱方自办</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="service-around">
                        <div className="around-item">
                            <Form.Item label="清关方式">
                                {getFieldDecorator('clearType', {
                                    initialValue: this.state.clearType ? this.state.clearType : '2',
                                })(
                                    <Radio.Group onChange={this.clearTypeOnChange} disabled={this.state.readOnly}>
                                        <Radio value={'1'}>山口快铁代办</Radio>
                                        <Radio value={'2'}>收货人自办</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </div>
                        <div className="around-item">
                            <Form.Item label="提货方式">
                                {getFieldDecorator('deliveryMethod', {
                                    initialValue: this.state.deliveryMethod ? this.state.deliveryMethod : '1',
                                    rules: [{required: true, message: '请填写提货方式'}]
                                })(
                                    <Radio.Group onChange={this.deliveryMethodOnChange} disabled={this.state.readOnly}>
                                        <Radio value={'1'}>山口快铁提货</Radio>
                                        <Radio value={'2'}>客户送货</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </div>
                <div className="order-base-title">
                    提货信息
                </div>
                <div className="space-base-content">
                    <div className="base-info" style={{height: 'auto'}}>
                        <Row>
                            <Col span={12}>
                                <span className='title'>提货地址:</span>
                                <span className='address-detail'>{this.state.collectAddr}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>联系人 : </span>
                                <span className='address-detail'>{this.state.collectContact}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>联系电话:</span>
                                <span className='address-detail'>{this.state.collectPhone}</span>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="order-base-title">
                    商品信息
                </div>
                <div className="order-goods-content">
                    <CarbinPackageModal
                        onRef={this.onRef}
                        visible={this.state.visible}
                        hideModal={this.hideModal}
                        saveData={this.saveData}
                        editingKey={this.state.editingKey}
                    />
                    <Table columns={columns} bordered dataSource={this.state.cabinPackageVoList} size="middle"/>
                    <div>
                        <AuthButton authority="order_edit:cabin_add" type="primary" onClick={this.showModal}
                                    style={{marginTop: '20px'}}>
                            添加货物
                        </AuthButton>
                    </div>
                </div>
                <SpaceModel
                    previewVisiable={this.state.previewVisiable}
                    hideModal={ this.previewhideModal }
                    previewData={this.state.previewData}
                />
                <Form.Item className="order-track-opt">
                    {this.state.readOnly ? '' :
                        <AuthButton authority="" type='primary' onClick={this.confirmBook}>订舱确认</AuthButton>}
                    <AuthButton authority="" type='primary' htmlType='submit'>保存</AuthButton>
                    <AuthButton authority="" type='primary' onClick={this.downloadPdf}>下载</AuthButton>
                    <AuthButton authority="" type='primary' onClick={this.previewShowModal}>预览</AuthButton>
                </Form.Item>
            </Form>
        )
    }
}
const KtWrappedOrderSpaceForm = Form.create()(KtOrderSpace);
export default  KtWrappedOrderSpaceForm;